<evc-platform
  [inputAppIdentification]="appIdentification"
  inputForcedTheme="light"
  [inputUserProfile]="useEVCPlatform ? null : currentUser"  
>
<app-inspection-setup top-bar-extra-settings></app-inspection-setup>
<main *ngIf="ready$ | async">
  <router-outlet></router-outlet>
</main>
</evc-platform>